import { Component, HostListener, OnInit } from '@angular/core';
import { ThemeService } from '@services/theme/theme.service';
import { NotificationService } from '@services/notification.service';
import { UpdateService } from '@services/update.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.web.html',
  styleUrls: ['./app.component.web.scss']
})
export class AppComponent implements OnInit {
  private readonly DESKTOP_MIN_WIDTH = 1200;
  public isDesktop = window.innerWidth >= this.DESKTOP_MIN_WIDTH;

  constructor(
    private themeService: ThemeService,
    private notificationService: NotificationService,
    private updateService: UpdateService,
    private router: Router
  ) {}

  ngOnInit() {
    this.checkWidth();
    if (this.isDesktop) {
      window.location.href = 'https://trocadatas.com/';
    }

    this.themeService.restore();
    this.notificationService.checkNotificationPermission();
    this.updateService.checkForUpdate();
  }

  @HostListener('window:resize')
  onResize() {
    this.checkWidth();

    if (this.isDesktop) {
      window.location.href = 'https://trocadatas.com/';
    }
  }

  private checkWidth() {
    this.isDesktop = window.innerWidth >= this.DESKTOP_MIN_WIDTH;
  }
}
